export const NAV_ANIMATION_DURATION_MS = 400;
